import { createSelector } from 'reselect';
import { dialogsReducerKey } from './DialogsConstants';

export function dialogsState(state) {
  return state.get(dialogsReducerKey);
}

export function dialogs(state) {
  return dialogsState(state).get('dialogs');
}

export function dialog(state, ownProps) {
  return dialogsState(state).getIn(['dialogs', ownProps.id]);
}

export function dialogsIds(state) {
  return dialogsState(state).get('dialogsIds');
}

export const renderBackdrop = createSelector([dialogs], (dialogsList) => dialogsList.some((d) => d.backdrop));
